// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ArrowUpward from "@store/Library/Components/Toolkit/Icons/ArrowUpward";
import Link, { LinkProps } from "@store/MobiusOverrides/Link/Link";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import React, { FC } from "react";

interface Styles {
    wrapper?: InjectableCss;
    backToTopLink?: LinkProps;
}

const styles: Styles = {
    wrapper: resultCountProps.bottomWrapper,
    backToTopLink: linkGetActionLinkProps(ArrowUpward),
};

const StyleguideFooter: FC = () => {
    const handleBackToTop = () => {
        window.scrollTo(0, 0);
        const elementToFocus = document.getElementById("collapseButton");
        if (elementToFocus) {
            elementToFocus.focus();
        } else {
            document.getElementById("expandButton")?.focus();
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link {...styles.backToTopLink} onClick={handleBackToTop}>
                {translate("Back to Top")}
            </Link>
        </StyledWrapper>
    );
};

export default StyleguideFooter;
